import { render, staticRenderFns } from "./exam-report.vue?vue&type=template&id=3dac1cf8&scoped=true&"
import script from "./exam-report.vue?vue&type=script&lang=ts&"
export * from "./exam-report.vue?vue&type=script&lang=ts&"
import style0 from "./exam-report.vue?vue&type=style&index=0&id=3dac1cf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dac1cf8",
  null
  
)

export default component.exports